import PropTypes from 'prop-types';

import ProductListPage from 'Component/ProductListPage';
import {
    ProductList as SourceProductList
} from 'SourceComponent/ProductList/ProductList.component';

import './ProductList.override.style';

/** @namespace Elganso/Component/ProductList/Component */
export class ProductListComponent extends SourceProductList {
    static propTypes = {
        ...this.propTypes,
        isPlp: PropTypes.bool
    };

    static defaultProps = {
        ...this.defaultProps,
        isPlp: false
    };

    observePageChange() {
        const { isLoading, loadPage } = this.props;

        if (isLoading) {
            this.pagesIntersecting = [];
        }

        if (!this.observer && 'IntersectionObserver' in window) {
            const threshold = this._getThreshold();

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(({ target, isIntersecting }) => {
                    const page = +Object.keys(this.nodes).find((node) => this.nodes[node] === target);
                    const index = this.pagesIntersecting.indexOf(page);

                    if (isIntersecting && index === -1) {
                        this.pagesIntersecting.push(page);

                        const lastPage = this.pagesIntersecting[this.pagesIntersecting.length - 1] + 1;

                        if (lastPage <= this.props.totalPages) {
                            loadPage(true);
                        }
                    }

                    if (!isIntersecting && index > -1) {
                        this.pagesIntersecting.splice(index, 1);
                    }
                });
            }, {
                root: null,
                rootMargin: '0px',
                threshold
            });
        }

        this.updateObserver();
    }

    renderPage(props = {}) {
        const {
            isInfiniteLoaderEnabled,
            loadPage,
            isLoading,
            isVisible,
            mix,
            isPlp,
            valueColumn,
            currentPage,
            pageSize
        } = this.props;

        const {
            items,
            keys,
            pageNumber,
            selectedFilters,
            wrapperRef,
            key
        } = this._processProps(props);

        return (
            <ProductListPage
              key={ key }
              isInfiniteLoaderEnabled={ isInfiniteLoaderEnabled }
              updatePages={ loadPage }
              isLoading={ isLoading }
              isVisible={ isVisible }
              mix={ mix }
              items={ items }
              keys={ keys }
              pageNumber={ pageNumber }
              pageSize={ pageSize }
              selectedFilters={ selectedFilters }
              wrapperRef={ wrapperRef }
              isPlp={ isPlp }
              valueColumn={ valueColumn }
              currentPage={ currentPage }
              loadPlaceholder={ key === undefined }
            />
        );
    }

    render() {
        const {
            totalPages,
            isLoading,
            mix
        } = this.props;

        if (!isLoading && totalPages === 0) {
            return this.renderNoProducts();
        }

        return (
            <div
              block="ProductList"
              mods={ { isLoading } }
              mix={ mix }
            >
                { this.renderTitle() }
                { this.renderPages() }
            </div>
        );
    }
}

export default ProductListComponent;
